module.exports = __webpack_public_path__ + "videos/about-2016.ba802fa.webm";